<h2 mat-dialog-title class="dialog-title">
  <mat-icon>{{ isEdit ? 'edit' : 'person_add' }}</mat-icon>
  <span>{{ isEdit ? 'Update Account' : 'Add Account' }}</span>
  <span class="spacer"></span>
  <button mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <div class="form-content">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Name</mat-label>
      <input matInput type="text" [(ngModel)]="name" placeholder="Enter account name">
    </mat-form-field>

    <app-email-login-field
      [control]="loginInfoEmailControl"
      (loginInfoChange)="onLoginInfoChange($event)"
      appearance="outline">
    </app-email-login-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="loading || !selectedLoginInfo">
    @if (loading) {
      <mat-spinner diameter="18"></mat-spinner>
    } @else {
      {{ isEdit ? 'Update' : 'Create' }}
    }
  </button>
</mat-dialog-actions>
